import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { genTaskApi } from "../../../api/genTaskApi";
import "./ExamByCategory.css";

export default function ExamAttemptHistory() {
  const { taskId } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [attempts, setAttempts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState(state?.title || "Task Attempt History");

  useEffect(() => {
    if (!taskId) return;
    loadData(taskId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);

  const loadData = async (id) => {
    setIsLoading(true);
    try {
      const [detailRes, historyRes] = await Promise.all([
        genTaskApi.taskDetail(id),
        genTaskApi.getAttemptHistory(id),
      ]);

      const details = detailRes?.success ? detailRes.data || [] : [];
      const history = historyRes?.success ? historyRes.data || [] : [];

      if (!state?.title && details.length > 0) {
        setTitle(details[0]?.taskId ? `Task ${id.slice(0, 8)}` : "Task Attempt History");
      }

      const totalQuestions = details.length;
      const mapped = history.map((attempt) => {
        const answerMap = new Map(
          (attempt.answers || []).map((item) => [item.questionId, item.value])
        );
        const correctCount = details.reduce((total, q) => {
          return total + (answerMap.get(q.questionId) === q.correctAnswer ? 1 : 0);
        }, 0);
        const scorePercent = totalQuestions
          ? Math.round((correctCount / totalQuestions) * 100)
          : 0;
        return {
          attemptId: attempt.attemptId,
          attemptNumber: attempt.attemptNumber,
          createTime: attempt.createdTime,
          totalQuestions,
          correctCount,
          scorePercent,
        };
      });
      setAttempts(mapped);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container py-4 exam-by-category">
      <section className="exam-hero mb-4">
        <div className="d-flex justify-content-between align-items-start gap-2">
          <div>
            <h2 className="exam-title mb-1">Attempt History</h2>
            <p className="exam-subtitle mb-0">{title}</p>
            <p className="exam-subtitle mb-0 small">Task ID: {taskId}</p>
          </div>
          <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate("/exam/category")}>
            Back
          </button>
        </div>
      </section>

      <div className="exam-card p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">All Attempts of This Task</h5>
          <span className="history-count">{attempts.length}</span>
        </div>

        {isLoading && <div className="text-muted">Loading history...</div>}

        {!isLoading && attempts.length === 0 && (
          <div className="text-muted">
            Task này chưa có lần làm nào.
          </div>
        )}

        {!isLoading && attempts.length > 0 && (
          <div className="attempt-history">
            {attempts.map((item) => (
              <div key={item.attemptId} className="attempt-item">
                <div className="d-flex justify-content-between align-items-start gap-2">
                  <div>
                    <div className="attempt-title">Attempt #{item.attemptNumber}</div>
                    <div className="attempt-time">
                      {new Date(item.createTime).toLocaleString("vi-VN")}
                    </div>
                  </div>
                  <span
                    className={`attempt-badge ${
                      item.scorePercent >= 80 ? "attempted" : "pending"
                    }`}
                  >
                    {item.scorePercent}%
                  </span>
                </div>
                <div className="attempt-score mt-2">
                  {item.correctCount}/{item.totalQuestions} correct
                </div>
                <div className="mt-2">
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() =>
                      navigate("/exam/view", {
                        state: {
                          taskId,
                          attemptId: item.attemptId,
                          title,
                          attemptNumber: item.attemptNumber,
                        },
                      })
                    }
                  >
                    <i className="bi bi-eye me-1"></i>
                    View details
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
